// components/Events/StackEvent.tsx

import React, { useContext } from 'react';
import './StackEvent.css';
import GameAssetsContext from '../../../../../../../context/GameAssetContext';
import { GameLog } from '../../../../../Logs/LogsDisplay';
import { getUniversalSourceIcon } from '../StatChangeEvent';

interface StackEventProps {
  log: GameLog;
  isGreyscale?: boolean;
}

const StackEvent: React.FC<StackEventProps> = ({ log, isGreyscale = false }) => {
  const { gameWideAssets, championsAssets } = useContext(GameAssetsContext);

  const details = log.details;
  const { stackName, stackType, currentStacks, maxStacks, championName } = details;
  const imageState = log.imageState;

  // Use the universal image fetching function
  const sourceIcon = getUniversalSourceIcon(
    {
      sourceType: stackType === 'Champion Passive' ? 'Passive' : stackType,
      imageState: imageState,
      sourceName: stackName,
      championName: championName,
      abilityKey: stackType === 'Ability' ? stackName : undefined, // Pass stackName as abilityKey for abilities
    },
    gameWideAssets,
    championsAssets
  );

  // Apply greyscale class if needed
  let finalSourceIcon = sourceIcon;
  if (isGreyscale && React.isValidElement(sourceIcon) && sourceIcon.type === 'img') {
    finalSourceIcon = React.cloneElement(sourceIcon as React.ReactElement<any>, {
      className: `${sourceIcon.props.className} greyscale`
    });
  }

  // Determine stack display: show "current/max" if maxStacks exists and is meaningful, otherwise just show current
  const stackDisplay = (maxStacks && maxStacks !== 9999) 
    ? `${currentStacks}/${maxStacks}` 
    : `${currentStacks}`;

  return (
    <div className={`stack-event ${isGreyscale ? 'greyscale' : ''}`}>
      {finalSourceIcon}
      <span className="stack-count">
        {stackDisplay}
      </span>
    </div>
  );
};

export default StackEvent;
